var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SimpleData from "../class/SimpleData.js";
import { log, round, showTable } from "../exports/helpers.js";
export function logCall() {
    return function (_, key, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    descriptor) {
        const wrappedFunc = descriptor.value;
        descriptor.value = function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...args) {
            logParameters(this, key, args);
            const start = Date.now();
            const result = wrappedFunc.apply(this, args);
            logDataAndDuration(this, result, start, key);
            return result;
        };
        return descriptor;
    };
}
export function asyncLogCall() {
    return function (_, key, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    descriptor) {
        const wrappedFunc = descriptor.value;
        descriptor.value = function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...args) {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.verbose) {
                    log("\n" + key + "()");
                    this.logParameters && log("parameters:");
                    this.logParameters && log(args);
                }
                const start = Date.now();
                const result = yield wrappedFunc.apply(this, args);
                logDataAndDuration(this, result, start, key);
                return result;
            });
        };
        return descriptor;
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function logParameters(sd, key, args) {
    if (sd.verbose) {
        log("\n" + key + "()");
        log("parameters:");
        log(args);
    }
}
function logDataAndDuration(sd, result, start, key) {
    const end = Date.now();
    const duration = end - start;
    sd.duration = sd.duration + duration;
    if (sd.verbose) {
        if (!key.includes("Chart") && !key.includes("save")) {
            const data = result instanceof SimpleData ? result.getData() : result;
            showTable(data, sd.nbTableItemsToLog);
        }
        log(`Done in ${round(duration / 1000, 3)} sec. / Total duration ${round(sd.duration / 1000, 3)}.`);
    }
}
//# sourceMappingURL=logCall.js.map